import { faWifiExclamation } from "@fortawesome/pro-solid-svg-icons";
import { Button, Text } from "@growtherapy/sprout-ui";
import { ModifiedToastAria, Toast, ToastVariant } from "../toasts";
import { QualityMode, useStoredAudioVideoSettings } from "../video-sdk";

type UnstableInternetToastProps = ModifiedToastAria & {
  onOpenSettings: () => void;
  isPerformanceMode: boolean;
};

export function UnstableInternetToast({
  contentProps,
  descriptionProps,
  isPerformanceMode,
  onOpenSettings,
  titleProps,
  ...toastAriaProps
}: UnstableInternetToastProps) {
  return (
    <Toast
      {...toastAriaProps}
      icon={faWifiExclamation}
      variant={ToastVariant.Info}
    >
      <div {...contentProps}>
        <Text as="span" {...titleProps}>
          Your internet connection is unstable.{" "}
        </Text>
        <Text as="span" {...descriptionProps}>
          {isPerformanceMode ? (
            "Try turning off your camera."
          ) : (
            <>
              <Button
                className="text-inherit"
                use="link"
                onClick={onOpenSettings}
              >
                Try changing your video quality
              </Button>{" "}
              or turning off your camera.
            </>
          )}
        </Text>
      </div>
    </Toast>
  );
}

export function UnstableInternetToastWrapper(
  props: Omit<UnstableInternetToastProps, "isPerformanceMode">,
) {
  const isPerformanceMode =
    useStoredAudioVideoSettings().storedAudioVideoSettings?.videoQualityMode ===
    QualityMode.Low;

  return (
    <UnstableInternetToast {...props} isPerformanceMode={isPerformanceMode} />
  );
}
